import { DefaultPageTemplate } from '@@/common/components/default-page-template';
import { AuthorizeRequired } from '@@/auth/components/authorize-required';

import styles from './index.module.sass';

export function NoAuthorizedPage() {
  return (
    <DefaultPageTemplate className={styles.root}>
      <AuthorizeRequired />
    </DefaultPageTemplate>
  );
}
